import { Switch } from '@mui/material';
import React from 'react';

import { useAppContext } from '@/hooks/use-app-context';

/**
 * SyncToggleコンポーネントのプロパティ
 */
export interface SyncToggleProps {
  /** ゲストモードかどうか */
  isGuest: boolean;
  /** トグル操作時のカスタムハンドラー（省略可） */
  onToggle?: () => void;
}

/**
 * 同期切り替えトグルコンポーネント
 *
 * ゲストモードの場合のみ表示され、ホストとの同期を有効/無効にするトグルスイッチを提供します。
 * 左上に配置され、「ホスト操作に追従」というテキストとトグルスイッチで構成されます。
 */
export function SyncToggle({ isGuest, onToggle }: SyncToggleProps) {
  const { state, toggleSync } = useAppContext();
  const { isSyncEnabled } = state;

  // トグル関数（カスタムハンドラーがあればそれを使用、なければデフォルトのtoggleSync）
  const handleToggle = onToggle || toggleSync;

  // ゲストモードでない場合は表示しない
  if (!isGuest) {
    return null;
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: '270px',
        left: '88px',
        width: '210px',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderRadius: '100px',
        padding: '2px 2px 2px 16px',
        color: 'white',
        zIndex: 1000,
        fontFamily: 'sans-serif',
        fontSize: '16px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
      }}
    >
      <span style={{ marginRight: '0px' }}>ホスト操作に追従</span>
      <Switch
        checked={isSyncEnabled}
        color='success'
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': {
            color: '#13BF83'
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#13BF83'
          }
        }}
        onChange={(e) => {
          e.stopPropagation();
          console.log('[TOGGLE_CLICK] Switch toggled, current state:', state.isSyncEnabled);

          // トグル関数を呼び出す
          handleToggle();
          console.log('[TOGGLE_CALL] Toggle handler called, waiting for state update...');

          // 非同期で状態の変更を確認（デバッグ用）
          setTimeout(() => {
            console.log('[TOGGLE_AFTER] After 500ms, state is:', state.isSyncEnabled);
          }, 500);
        }}
      />
    </div>
  );
}
